"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/Twitter/index.ts
var Twitter_exports = {};
__export(Twitter_exports, {
  Embed: () => Embed,
  getTwitterIdFromUrl: () => getTwitterIdFromUrl,
  isValidTwitterUrl: () => isValidTwitterUrl
});
module.exports = __toCommonJS(Twitter_exports);

// src/components/Twitter/Embed.tsx
var import_react2 = __toESM(require("react"));
var import_loadjs = __toESM(require("loadjs"));

// src/components/Twitter/util.ts
function isValidTwitterUrl(url) {
  const regExp = /^((?:https?:)?\/\/)?((?:www|m|mobile)\.)?((?:twitter|twttr|x)\.com)/;
  const twitterId = getTwitterIdFromUrl(url);
  return regExp.test(url) && !!twitterId;
}
function getTwitterIdFromUrl(tweetUrl) {
  var _a;
  try {
    const url = new URL(tweetUrl);
    const twitterId = (_a = url.pathname.split("/").pop()) != null ? _a : "";
    if (!/^\d+$/.test(twitterId))
      return null;
    return twitterId;
  } catch (e) {
    return null;
  }
}

// src/components/EmbedErrorState/EmbedErrorState.tsx
var import_react = __toESM(require("react"));

// node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var faImageSlash = {
  prefix: "fas",
  iconName: "image-slash",
  icon: [640, 512, [], "e1b7", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-55.5-43.5c.5-3.1 .7-6.3 .7-9.6V96c0-35.3-28.7-64-64-64H128c-14.4 0-27.8 4.8-38.5 12.9L38.8 5.1zm120 94.1c5.3-2 11.1-3.2 17.2-3.2c26.5 0 48 21.5 48 48c0 2-.1 4-.4 6L158.8 99.2zM328.1 231.9l20-29.4c4.5-6.6 11.9-10.5 19.8-10.5s15.4 3.9 19.8 10.5L499.4 366.1 328.1 231.9zM221.7 272.5c.3-.4 .6-.7 1-1.1L64 146.4V416c0 35.3 28.7 64 64 64H487.4l-81.2-64H320 248 152c-9.3 0-17.8-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l88-104z"]
};

// src/components/EmbedErrorState/EmbedErrorState.tsx
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
var EmbedErrorState = ({
  text,
  className = ""
}) => {
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    {
      className: `
        v2-w-64 v2-h-40 v2-bg-neutral-100 v2-text-neutral-500 v2-rounded-md
        v2-border v2-border-solid v2-border-neutral-300 v2-flex v2-flex-col
        v2-justify-center v2-text-center v2-text-base v2-items-center
        ${className}`
    },
    /* @__PURE__ */ import_react.default.createElement(import_react_fontawesome.FontAwesomeIcon, { className: "v2-h-7", icon: faImageSlash }),
    /* @__PURE__ */ import_react.default.createElement("div", { className: "v2-m-3.5" }, text)
  );
};

// src/components/Twitter/Embed.tsx
var import_styled = __toESM(require("@emotion/styled"));
var TW_SCRIPT_NAME = "twttr";
var Container = import_styled.default.div`
  > div {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
`;
var twitterWidgetJs = "https://platform.twitter.com/widgets.js";
var Embed = ({
  containerRef,
  tweetUrl,
  className = "",
  errorStateClassName = "",
  embedParams,
  hideErrorState = false,
  onLoad,
  onLoadError
}) => {
  const ref = containerRef != null ? containerRef : (0, import_react2.useRef)(null);
  const [tweetLoadFailed, setTweetLoadFailed] = (0, import_react2.useState)(false);
  const isValidTwitter = isValidTwitterUrl(tweetUrl);
  const tweetId = (0, import_react2.useMemo)(() => getTwitterIdFromUrl(tweetUrl), [tweetUrl]);
  const loadTwitterWidget = () => {
    if (!import_loadjs.default.isDefined(TW_SCRIPT_NAME)) {
      (0, import_loadjs.default)(twitterWidgetJs, TW_SCRIPT_NAME);
    }
  };
  const onTweetLoadError = () => {
    setTweetLoadFailed(true);
    onLoadError == null ? void 0 : onLoadError();
  };
  (0, import_react2.useEffect)(() => {
    if (!isValidTwitter)
      return;
    if (ref == null ? void 0 : ref.current) {
      ref.current.innerHTML = "";
    }
    setTweetLoadFailed(false);
    loadTwitterWidget();
    import_loadjs.default.ready(TW_SCRIPT_NAME, {
      success: () => {
        const twttr = window[TW_SCRIPT_NAME];
        void (() => {
          var _a, _b;
          (_b = (_a = twttr.widgets).createTweet) == null ? void 0 : _b.call(_a, tweetId, ref == null ? void 0 : ref.current, embedParams).then((el) => {
            if (el) {
              onLoad == null ? void 0 : onLoad();
            } else {
              onTweetLoadError();
            }
          }).catch(() => onTweetLoadError());
        })();
      }
    });
  }, [tweetUrl, tweetId]);
  if ((!isValidTwitter || tweetLoadFailed) && hideErrorState) {
    return null;
  }
  if (!isValidTwitter) {
    onLoadError == null ? void 0 : onLoadError();
    return /* @__PURE__ */ import_react2.default.createElement(
      EmbedErrorState,
      {
        className: errorStateClassName,
        text: "The URL you've provided is not a valid Twitter URL."
      }
    );
  }
  if (tweetLoadFailed) {
    return /* @__PURE__ */ import_react2.default.createElement(
      EmbedErrorState,
      {
        className: errorStateClassName,
        text: "This post is no longer available. Please check the original link and try again."
      }
    );
  }
  return /* @__PURE__ */ import_react2.default.createElement(Container, { ref, className: `v2-w-full ${className}` });
};
